import { axiosPrivate } from '../api/axios'

const useLogout = () => {
	const logout = async () => {
		await axiosPrivate.get('/account/logout')
		localStorage.clear()
		sessionStorage.clear()

		window.location.href = '/login'
	}

	return logout
}

export default useLogout
